import { Component, OnInit } from "@angular/core";
import { BaseService } from "../base.service";
import { environment } from "../../../environments/environment";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import * as config from "../../../assets/grid_config.json";
import { Location } from "@angular/common";
import { forkJoin } from "rxjs";

@Component({
  selector: "app-list",
  templateUrl: "./list.component.html",
  styleUrls: ["./list.component.css"],
})
export class ListComponent implements OnInit {
  params = {
    trading_courses: false,
    top_rated: false,
    audio_courses: false,
    category: false,
    popular_list: false,
  };
  homeData: any = [];
  app_constant: any;
  shimarStatus = true;
  subcategory = [];
  gridConfig: any = (config as any).default;
  apiParam = {
    slug: "home",
    limit: 20,
    offset: 0,
    partner_id: "",
    feature: false,
    banner: false,
  };

  param = { limit: 20, offset: 0 };
  loadMore: boolean;
  load = false;
  count: any;
  constructor(
    private service: BaseService,
    private route: ActivatedRoute,
    public translate: TranslateService,
    public location: Location
  ) {
    // translate.setDefaultLang("en");
    // translate.use("en");
    // translate.addLangs(["en", "es"]);
  }

  ngOnInit(): void {
    this.app_constant = environment;
    this.route.queryParamMap.subscribe((params: any) => {
      if (params.params.partnar_id) {
        this.apiParam.partner_id = params.params.partnar_id;
        this.getPopularData();
      } else {
        this.apiParam.partner_id = "";
        this.getPopularData();
      }
    });
  }
  getData() {
    this.service.homeService(this.apiParam).subscribe((data: any) => {
      this.homeData = data;
      if (data.content.length > 0) {
        this.subcategory = this.subcategory.concat(data.content);
        this.loadMore = false;
        this.shimarStatus = false;
      } else {
        this.loadMore = false;
        this.shimarStatus = false;
      }
    });
  }
  getPopularData() {
    this.route.params.subscribe((params) => {
      if (params["list"]) {
        if (params.list === "popular-trending-series") {
          window.scrollTo(0, 0);
          this.params.trading_courses = true;
          this.loadMore = true;
          this.service.popularCourses(this.param).subscribe((data: any) => {
            if (data.results.length > 0) {
              this.count = data.counts;
              this.shimarStatus = false;
              this.subcategory = this.subcategory.concat(data.results)
              this.load = true;
              this.loadMore = false;
            } else {
              this.load = false;
              this.loadMore = false;
            }
          });
        } else if (params.list === "popular-list") {
          window.scrollTo(0, 0);
          this.params.popular_list = true;
          this.loadMore = true;
          this.service.mostPopular(this.param).subscribe((data: any) => {
            if (data.results.length > 0) {
              this.count = data.counts;
              this.shimarStatus = false;
              this.subcategory = this.subcategory.concat(data.results)
              this.load = true;
              this.loadMore = false;
            } else {
              this.load = false;
              this.loadMore = false;
            }
          });
        } else if (params.list === "top-rated-contents") {
          window.scrollTo(0, 0);
          this.params.top_rated = true;
          this.loadMore = true;
          this.service.popularContent(this.param).subscribe((data: any) => {
            if (data.results.length > 0) {
              this.count = data.counts;
              this.shimarStatus = false;
              this.subcategory = this.subcategory.concat(data.results)
              this.load = true;
              this.loadMore = false;
            } else {
              this.load = false;
              this.loadMore = false;
            }
          });
        } else if (params.list === "popular-trending-contents") {
          window.scrollTo(0, 0);
          this.params.audio_courses = true;
          this.loadMore = true;
          this.service
            .trendingContentAudio(this.param)
            .subscribe((data: any) => {
              if (data.results.length > 0) {
                this.shimarStatus = false;
                this.subcategory = this.subcategory.concat(data.results);
                this.load = true;
                this.loadMore = false;
              } else {
                this.load = false;
                this.loadMore = false;
              }
            });
        } else {
          this.apiParam.slug = params["list"];
          window.scrollTo(0, 0);
          this.params.category = true;
          this.getData();
        }
      }
    });
  }
  onScroll() {
    this.loadMore = true;
    const offset = this.param.limit + this.param.offset;
    if (this.homeData.length === 0 && this.load) {
      if (this.count > offset) {
        this.param.offset = this.param.limit + this.param.offset;
        this.getPopularData();
      } else {
        this.loadMore = false;
      }
    } else if (this.homeData?.content?.length > 0) {
      const offset = this.apiParam.limit + this.apiParam.offset;
      if (this.homeData?.content?.length == offset) {
        this.apiParam.offset = this.apiParam.limit + this.apiParam.offset;
        this.getData();
      } else {
        this.loadMore = false;
      }
    }
  }
}
